import { Navigate } from 'react-router-dom';
import { useRole } from '../../hooks/useRole';

export default function AdminRoute({ children }) {
  const { hasAdminAccess, loading, approved } = useRole();

  if (loading) return <p>Loading...</p>;
  if (!approved) return <Navigate to="/" />;
  if (!hasAdminAccess) return <Navigate to="/unauthorized" />;
  
  return children;
}